import { DrawerDialog, DrawerDialogProps } from '@/common/components/drawer-dialog';
import { LoaderButton } from '@/common/components/loader-button';
import Spacer from '@/common/components/spacer';
import StatusBanner from '@/common/components/status-banner';
import { getStandardCurrency } from '@/util-conversion/currency';
import { Form } from 'react-router';
import { MouseEventHandler } from 'react';
import { capitalizeOnlyFirstLetter } from '@/util-conversion/misc';

export interface PayOverdueBalanceDrawerDialogProps extends DrawerDialogProps {
  unpaidBalance: number;
  isSelectingVehicle: boolean;
  cardType?: string;
  cardLast4?: string;
  paymentError?: string;
  handleUpdatePaymentMethod: MouseEventHandler<HTMLButtonElement>;
}
export default function PayOverdueBalanceDrawerDialog({
  unpaidBalance,
  isSelectingVehicle,
  cardType,
  cardLast4,
  open,
  paymentError,
  handleClose,
  handleUpdatePaymentMethod,
}: PayOverdueBalanceDrawerDialogProps) {
  const hasCard = cardType && cardLast4;

  const copy = (() => {
    if (isSelectingVehicle) {
      const cardCopy = hasCard
        ? `. You can retry a payment of ${getStandardCurrency(unpaidBalance)} using ${capitalizeOnlyFirstLetter(cardType)} ending in ${cardLast4} now, or update your payment method.`
        : ` by updating your payment method.`;

      return `In order to swap vehicles, you need to pay your overdue balance ${cardCopy}`;
    }

    const cardCopy = hasCard
      ? `using ${capitalizeOnlyFirstLetter(cardType)} ending in ${cardLast4} now, or update your payment method`
      : `by updating your payment method`;

    return `Retry payment of ${getStandardCurrency(unpaidBalance)} ${cardCopy}.`;
  })();

  return (
    <DrawerDialog open={open} handleClose={handleClose} title={'Pay overdue balance'}>
      {paymentError ? (
        <>
          <StatusBanner
            variant="error"
            message={{ text: paymentError }}
            shouldScrollToTop={true}
          />
          <Spacer variant="height16" />
        </>
      ) : null}

      <p className="body">{copy}</p>
      <Spacer variant="height16" />
      <Form method="post">
        {hasCard ? (
          <LoaderButton
            variant="primary"
            type="submit"
            name="intent"
            value="pay-overdue-balance"
            className="body-strong mt-4 w-full"
          >
            Retry payment
          </LoaderButton>
        ) : null}

        <LoaderButton
          type="button"
          variant="secondary"
          className="body-strong mt-4 w-full"
          onClick={handleUpdatePaymentMethod}
        >
          Update payment method
        </LoaderButton>
      </Form>
    </DrawerDialog>
  );
}
